class AxiomAddons extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.form = this.closest('form');
    this.variants = JSON.parse(this.querySelector('[data-addon-variants]').textContent);
    this.variantId = this.form.elements.namedItem('id').value;
    this.inputs = [...this.querySelectorAll('[data-addon]')];
    const section = this.closest('.shopify-section');
    this.addEventListener('change', () => this.refresh(), { signal });
    this.form.addEventListener('input', () => this.refresh(), { signal });
    this.form.addEventListener('quantity-selector:update', () => this.refresh(), { signal });
    section?.addEventListener('variant:update', (event) => {
      if (String(event.detail.data.productId) !== this.dataset.productId) return;
      this.variantId = String(event.detail.resource?.id || '');
      this.refresh();
    }, { signal });
    this.hidden = false;
    this.refresh();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  get quantity() {
    return Math.max(1, Number(this.form.elements.namedItem('quantity')?.value) || 1);
  }

  get selected() {
    return this.inputs.filter((input) => input.checked && !input.disabled);
  }

  refresh() {
    const variant = this.variants[this.variantId];
    const included = variant?.included || [];
    for (const input of this.inputs) {
      const isIncluded = included.includes(input.dataset.kind);
      const unavailable = input.dataset.available !== 'true';
      input.disabled = isIncluded || unavailable || !variant;
      if (input.disabled) input.checked = false;
      const row = input.closest('.axiom-addons__option');
      row.toggleAttribute('data-included', isIncluded);
      row.querySelector('[data-addon-status]').textContent = isIncluded ? (input.dataset.kind === 'flex' ? this.dataset.flexIncluded : this.dataset.included) : unavailable ? this.dataset.unavailable : '';
    }
    const harness = this.inputs.find((input) => input.dataset.kind === 'harness');
    const kitSelected = this.selected.some((input) => ['boost', 'flex'].includes(input.dataset.kind));
    if (harness && kitSelected && !included.includes('harness')) {
      harness.checked = false;
      harness.disabled = true;
      const row = harness.closest('.axiom-addons__option');
      row.setAttribute('data-included', '');
      row.querySelector('[data-addon-status]').textContent = this.dataset.kitIncluded;
    }
    const cents = ((variant?.price || 0) + this.selected.reduce((sum, input) => sum + Number(input.dataset.price), 0)) * this.quantity;
    this.querySelector('[data-addon-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency }).format(cents / 100);
  }

  buildFormData(original) {
    this.variantId = String(original.get('id'));
    this.refresh();
    if (!this.selected.length) return original;
    const data = new FormData();
    const group = crypto.randomUUID();
    for (const [key, value] of original.entries()) {
      if (['id', 'quantity', 'selling_plan'].includes(key) || key.startsWith('properties[')) {
        const nested = key.startsWith('properties[') ? `items[0][properties]${key.slice(10)}` : `items[0][${key}]`;
        data.append(nested, value);
      } else if (['sections', 'sections_url'].includes(key)) {
        data.set(key, value);
      }
    }
    data.set('items[0][quantity]', String(this.quantity));
    data.set('items[0][properties][_axiom_configuration]', group);
    this.selected.forEach((input, index) => {
      const prefix = `items[${index + 1}]`;
      data.set(`${prefix}[id]`, input.value);
      data.set(`${prefix}[quantity]`, String(this.quantity));
      data.set(`${prefix}[properties][_axiom_configuration]`, group);
      data.set(`${prefix}[properties][ECU configuration]`, this.variants[this.variantId].title);
      for (const name of ['Vehicle Year', 'Vehicle Make', 'Vehicle Model / Trim']) {
        const value = original.get(`properties[${name}]`);
        if (value) data.set(`${prefix}[properties][${name}]`, value);
      }
    });
    return data;
  }
}

if (!customElements.get('axiom-addons')) customElements.define('axiom-addons', AxiomAddons);
